import React from "react";

function AllSelectBtn({
  value,
  allValue = "ALL",
  handleClick,
  buttonText = "ALL",
}) {
  return (
    <button
      type="button"
      className={`rounded px-2 py-1 font-semibold ${
        value === allValue
          ? "bg-indigo-200 text-indigo-900"
          : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
      }`}
      onClick={handleClick}
    >
      {buttonText}
    </button>
  );
}

export default AllSelectBtn;
